import React from "react";
import Select from "react-select";

import loadIcon from "../../../assets/images/tail-spin.svg";
export const CustomSelectDropdown = React.forwardRef(function SelectDropdown(
  { defaultValue, placeholder, onChange, styles, options, isLoading, ...rest },
  ref,
) {
  return (
    <>
      <Select
        defaultValue={defaultValue}
        onChange={onChange}
        styles={styles}
        options={options}
        components={{
          LoadingIndicator: () =>
            isLoading && (
              <img className="mx-auto h-3 w-3" src={loadIcon} alt="loading..." />
            ),
        }}
        placeholder={placeholder}
        isLoading={isLoading}
        isDisabled={isLoading}
        {...rest}
      />
    </>
  );
});
